/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { sharedMyAccountDetailsLinesStyles } from "@monsma/App/ComponentExtensions/OrderLinesListExtension";
import { cardStyles } from "@monsma/Overrides/Widgets/InvoiceDetails/InvoiceDetailsLineCard";
import { css } from "styled-components";

(cardStyles as any).imageWrapper = sharedMyAccountDetailsLinesStyles.imageWrapper;

cardStyles.qtyStyles = sharedMyAccountDetailsLinesStyles.smallHeadingAndTextContent;

(cardStyles as any).priceHeading = {
    variant: "legend",
};

(cardStyles as any).priceText = {
    ...sharedMyAccountDetailsLinesStyles.smallHeadingAndTextContent?.text,
};

(cardStyles as any).priceSubText = sharedMyAccountDetailsLinesStyles.priceSubText;

cardStyles.subtotalWithoutVatHeadingAndText = {
    ...sharedMyAccountDetailsLinesStyles.smallHeadingAndTextContent,
    wrapper: {
        css: css`
            margin-top: 10px;
        `,
    },
};

cardStyles.totalStyles = {
    ...cardStyles.subtotalWithoutVatHeadingAndText,
    wrapper: {
        css: css`
            @media print {
                margin-top: 0;
                margin-left: 10px;
                width: auto;
                flex-grow: 1;
            }
        `,
    },
};

(cardStyles as any).priceWrapper = {
    css: css`
        @media print {
            flex-grow: 1;
        }
    `,
};

cardStyles.vatLabelText = sharedMyAccountDetailsLinesStyles.vatLabelText;

(cardStyles as any).orderLineLabel = sharedMyAccountDetailsLinesStyles.orderLineLabel;

(cardStyles as any).orderLineText = sharedMyAccountDetailsLinesStyles.orderLineText;
